import {
  SessionSiteSelectors,
  SessionUserSelectors
} from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { AppState } from '~src/bootstrap/redux/state/AppState';
import { getAppStore } from '~src/bootstrap/redux/store/AppStore';
import { UpdateShowPrepConductorAwarenessRequest } from '~src/flow/serverApi/requests/UpdateShowPrepConductorAwarenessRequest';
import { WebHttpClientWithErrorToastInstance } from '~src/httpClient/WebHttpClientWithErrorToast';
import { getSessionManagementServiceInstance } from '~src/sessionManagement/SessionManagementService';
import { SiteRolesUtil } from '~src/userManagement/services/resources/SiteRolesUtil';

export function showPrepConductorAwareness() {
  const state = getAppStore().getState();
  const isUserSettingEnabled = SessionUserSelectors.showPrepConductorAwareness(state);
  const isDataManagementEnabled = SessionSiteSelectors.isDataManagementEnabled(state);
  const isRoleValid = checkSiteRoleForPrepConductorAwareness(state);
  return isUserSettingEnabled && !isDataManagementEnabled && isRoleValid;
}

export function checkSiteRoleForPrepConductorAwareness(state: AppState) {
  const siteRole = SessionSiteSelectors.siteRole(state);
  return SiteRolesUtil.isCreatorOrServerAdmin(siteRole);
}

export function checkSiteRoleForCatalogAwareness(state: AppState) {
  const siteRole = SessionSiteSelectors.siteRole(state);

  return SiteRolesUtil.isSiteExplorerOrHigher(siteRole);
}

export function sendDisableConductorAwarenessRequest() {
  WebHttpClientWithErrorToastInstance.sendRequestAndDelay(
    new UpdateShowPrepConductorAwarenessRequest({
      enabled: false
    })).then(() => getSessionManagementServiceInstance().refreshSessionInfo());
}

export function shouldShowPrepConductorAwarenessSetting() {
  const state = getAppStore().getState();
  const dataManagementEnabled = SessionSiteSelectors.isDataManagementEnabled(state);
  return !dataManagementEnabled && checkSiteRoleForPrepConductorAwareness(state);
}

